import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import FooterLayouts from "../layouts/footer.layout";
import BannerComponent from "../components/politicas_terminos_reserva/banner.component";
import TitleComponent from "../components/politicas_terminos_reserva/title.component";
import AccordionComponent from "../components/politicas_terminos_reserva/accordion.component";
import DescriptionComponent from "../components/politicas_terminos_reserva/description.component";
import { politicasTerminosReserva } from "../components/conexion/politica.conexion";

const PoliticasTerminosReservasPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [politicas, setPoliticas]: any = useState([]);

  useEffect(() => {
    politicasTerminosReserva().then(function (res: any) {
      setPoliticas(res?.data?.data[0]);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>
        <BannerComponent />
        <TitleComponent />
        <DescriptionComponent politicas={politicas} />
        <AccordionComponent politicas={politicas} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default PoliticasTerminosReservasPage;
